import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { Theme } from '@mui/material/styles';
import useTheme from '@mui/material/styles/useTheme';

import makeStyles from '@mui/styles/makeStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { SxProps } from '@mui/system';

interface HelperIconProps {
  message?: string;
  color?: 'primary' | 'secondary';
  fontSize?: number | 'inherit';
  placement?: 'bottom-end' | 'bottom-start' | 'bottom' | 'left-end' | 'left-start' | 'left' | 'right-end' | 'right-start' | 'right' | 'top-end' | 'top-start' | 'top';
  sx?: SxProps<Theme>;
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    infoIcon: {
      '&:hover': {
        color: theme.palette.secondary.main,
      },
    },
  }),
  { name: 'HelperIcon' },
);

const HelperIcon: React.FC<HelperIconProps> = ({ message = '', fontSize = 14, placement = 'right', color = undefined, sx = undefined }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Tooltip enterTouchDelay={50} leaveTouchDelay={3000} title={message} placement={isDesktop ? placement : 'bottom'} arrow>
      <InfoOutlinedIcon color={color} fontSize="inherit" sx={{ fontSize, verticalAlign: 'middle', ...sx }} className={classes.infoIcon} />
    </Tooltip>
  );
};

export default HelperIcon;
